module.exports = __webpack_public_path__ + "media/images/prandi 2-c7353baa157558c549c1b12ca69b7c85.jpg";